import { gql } from 'apollo-angular';

export const GET_REGIONAL_CONFIG = gql`
  query ($id: ID!) {
    regionalConfig(id: $id) {
      id
      tenantId
      description
      currency
      timezone
      bankHolidays
      ignoredDaysOfWeek
      defaultPhoneRegionCode
      timetable
      collectors {
        id
        name
      }
    }
  }
`;

export const GET_REGIONAL_CONFIGS_LIST = gql`
  query ($tenantId: ID!) {
    regionalConfigs(tenantId: $tenantId) {
      id
      tenantId
      description
      currency
      timezone
      timetable
      collectors {
        id
        name
      }
    }
  }
`;

export const DELETE_REGIONAL_CONFIGS = gql`
  mutation ($id: ID!) {
    deleteRegionalConfig(id: $id) {
      id
    }
  }
`;

export const ADD_REGIONAL_CONFIGS = gql`
  mutation ($input: CreateRegionalConfigInput!) {
    createRegionalConfig(input: $input) {
      id
      tenantId
      description
      currency
      timezone
      bankHolidays
      ignoredDaysOfWeek
      timetable
    }
  }
`;

export const UPDATE_REGIONAL_CONFIGS = gql`
  mutation ($id: ID!, $input: UpdateRegionalConfigInput!) {
    updateRegionalConfig(id: $id, input: $input) {
      id
      tenantId
      description
      currency
      timezone
      bankHolidays
      ignoredDaysOfWeek
      defaultPhoneRegionCode
      timetable
    }
  }
`;
